export enum DontHaveKitSteps {
  REQUEST = 0,
  PROCESSING = 1,
  DIRECT_TRANSIT = 2,
  DIRECT_DELIVERED = 4,
  RETURN_TRANSIT = 5,
  COMPLETED = 7,
}
